
<!-- Issue 89 - Extract breakdown list -->
<div class="card-header" id="breakdownListHeader">
  <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
      data-target="#breakdownListCollapse" aria-expanded="true" aria-controls="breakdownListCollapse">
      Liste des pannes
  </button>
</div>

<div id="breakdownListCollapse" class="panel-collapse collapse" aria-labelledby="breakdownListHeader"
    data-parent="#accordionExtraction">
    <div class="card-body row">
        <form [formGroup]="breakdownListForm" (ngSubmit)="onSubmitBreakdownList()" class="wrapper shadowed">
            <h4>Liste des pannes</h4>
            <br>
            <div class="paragraphe">
                <mat-form-field>
                    <input matInput [matDatepicker]="pickerstartBreakdownDate" placeholder="Date de début"
                        formControlName="startBreakdownDate">
                    <mat-datepicker-toggle matSuffix [for]="pickerstartBreakdownDate"></mat-datepicker-toggle>
                    <mat-datepicker #pickerstartBreakdownDate startView="month"></mat-datepicker>
                </mat-form-field>
                <mat-form-field>
                    <input matInput [matDatepicker]="pickerendBreakdownDate" placeholder="Date de fin"
                        formControlName="endBreakdownDate">
                    <mat-datepicker-toggle matSuffix [for]="pickerendBreakdownDate"></mat-datepicker-toggle>
                    <mat-datepicker #pickerendBreakdownDate startView="month"></mat-datepicker>
                </mat-form-field>
                <mat-form-field>
                  <mat-label>N° de série</mat-label>
                  <input matInput formControlName="serialNumber">
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Code panne</mat-label>
                  <input matInput formControlName="breakdownCode">
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Panne</mat-label>
                  <input matInput formControlName="subjectBreakdown">
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Regroupement</mat-label>
                  <mat-select formControlName="groupBreakdown" placeholder="Regroupement">
                    <mat-option [value]="0">Aucun</mat-option>
                    <mat-option [value]="1">N° série / Panne</mat-option>
                    <mat-option [value]="2">Panne</mat-option>
                    <mat-option [value]="3">N° série</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field>
                  <input matInput [matDatepicker]="pickerBeginServiceDate" placeholder="Mise en service après le "
                      formControlName="beginServiceDate">
                  <mat-datepicker-toggle matSuffix [for]="pickerBeginServiceDate"></mat-datepicker-toggle>
                  <mat-datepicker #pickerBeginServiceDate startView="month"></mat-datepicker>
              </mat-form-field>

                <mat-form-field>
                  <input matInput [matDatepicker]="pickerEndServiceDate" placeholder="Mise en service avant le "
                      formControlName="endServiceDate">
                  <mat-datepicker-toggle matSuffix [for]="pickerEndServiceDate"></mat-datepicker-toggle>
                  <mat-datepicker #pickerEndServiceDate startView="month"></mat-datepicker>
              </mat-form-field>

            </div>

            <button type="submit" class="btn btn-primary" style="margin-left: 40px;">Valider</button>

            <br>
        </form>
        <br><br>

        <app-gmao-spinner *ngIf="isLoading"></app-gmao-spinner>

        <ng-container *ngIf="showData">
          <div class="wrapper shadowed">

              <br />

              <h4>Résultats</h4>
              <app-export-button [data]="getData()"></app-export-button>
              <br />

              <mat-table [dataSource]="breakdownList" matSort class="mat-elevation-z8">
                <ng-container matColumnDef="datepanne" *ngIf="isColumnDisplay('datepanne')">
                  <mat-header-cell *matHeaderCellDef mat-sort-header disableClear> Date de la panne </mat-header-cell>
                  <mat-cell *matCellDef="let rownb">{{getNiceDate(rownb.DATE_PANNE)}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="numeroserie" *ngIf="isColumnDisplay('numeroserie')">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> N° Série </mat-header-cell>
                  <mat-cell *matCellDef="let rownb">{{rownb.NUMERO_SERIE}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="departement" *ngIf="isColumnDisplay('departement')">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> Département </mat-header-cell>
                  <mat-cell *matCellDef="let rownb">{{rownb.DEPT}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="codepanne" *ngIf="isColumnDisplay('codepanne')">
                  <mat-header-cell *matHeaderCellDef> Code panne </mat-header-cell>
                  <mat-cell *matCellDef="let rownb">{{rownb.CODE_PANNE}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="panne" *ngIf="isColumnDisplay('panne')">
                  <mat-header-cell *matHeaderCellDef> Panne </mat-header-cell>
                  <mat-cell *matCellDef="let rownb">{{rownb.SUJET}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="total" *ngIf="isColumnDisplay('total')">
                  <mat-header-cell *matHeaderCellDef> Total </mat-header-cell>
                  <mat-cell *matCellDef="let rownb">{{rownb.NB}}</mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumnBreakdown"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumnBreakdown;"></mat-row>
              </mat-table>

              <mat-paginator #paginator [pageSize]="20" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
          </div>

        </ng-container>


        <br />
    </div>
</div>
